'use strict'

import Vue from 'vue'
import axios from 'axios'

import urlConfig from './url'




// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: urlConfig.baseUrl,
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  showLoading: true
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    if (config.showLoading) {
      Vue.prototype.$toast.loading({
        duration: 0,
        // 遮罩层
        // mask: true,
        forbidClick: true,
        message: '加载中...',
        loadingType: 'spinner',
      })
    }
    return config
  },
  function (error) {
    // Do something with request error
    Vue.prototype.$toast('网络出错，请重试')
    return Promise.reject(error)
  },
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    if (response.config.showLoading) {
      Vue.prototype.$toast.clear()
    }
    if (response.data.code == 200) {
      return response.data
    } else if (response.data.code == 400) {
      // Vue.prototype.$Notify({
      //   message: '自定义颜色',
      //   color: '#ad0000',
      //   background: '#ffe1e1',
      // })
      // console.log(response.data)
      return response.data
    } else {
      Vue.prototype.$toast('网络出错，请重试')
    }
    return response
  },
  function (error) {
    Vue.prototype.$toast('网络出错，请重试')
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin